import Vue from 'vue'
import Vuex from 'vuex'
import { sha256 } from 'js-sha256'
import router from './router';

Vue.use(Vuex)
const localStorage = window.localStorage
export default new Vuex.Store({
  state: {
    // office文档解析地址
    // 测试的
    officeUrl:'http://114.116.0.71',
    // 正式的
    // officeUrl:'http://114.116.0.71',
    // 用来记录某些未返回数据的接口
    axiosPromiseArr:[],
    newroute:'',
    factoryId:'',
    token: '',
    // 过期时间
    expireTime: '',
    authCode: '',
    // websocketws: 'v2.tst-cloud.com/',//39.98.235.36,172.16.0.121，
    websocketws: 'www.tst-cloud.com/',
    // websocketws: '192.168.2.12:28801/',
    // websocketws: '192.168.1.199:28801/',
    isRouterAlive: true,
    // 当前语言 0：英语；1：中文
    lang: 1,
    // 身份1: 管理员 2：普通用户
    roleId: '',
    // 默认公司机械id,车间id和工厂id
    defaultId: null,
    defaultFactoryId: null,
    defaultShopId: null,
    // 侧边导航栏展开还是缩小
    isCollapse: false,
    // StepCycleTime 一些data变量（为啥存这，因为要动态刷新datePicke快捷键，存在vue的变量会被清空
    machineID: [],
    selectOptions: [],
    selectValue: [],
    shiftTime: '',
    dateBtn1: '',
    dateBtn2: '',
    dateBtn3: '',
    dateBtn4: '',
    dateBtn5: '',
    datePicker: '',
    startPicker:'',
    endPicker:'',
    reloadState: false,
    stepSelectLoading: false,
    // 存在header里的参数
    sign: '',
    // 用户显示隐藏那些模块
    authority: null,
    accountId: null,
    // 登录用户的名称
    userName: '',
    isMarketAccount: '',
    // 营销账号的工厂列表
    marketFactoryList:[],
    machineList:[]
  },
  mutations: {
    login (state, data) {
      if(data.authList){
        localStorage.authority = JSON.stringify(data.authList)
        state.authority = data.authList
      }
      localStorage.token = data.token
      state.token = data.token
      localStorage.expireTime = data.expire_at
      state.expireTime = data.expire_at
      localStorage.authCode = data.auth_Code
      state.authCode = data.auth_Code
      localStorage.factoryId= data.factory_id
      state.factoryId = data.factory_id
      if (data.route !== null) {
        localStorage.newroute = data.route
        state.newroute = data.route
      }
      if (data.account.roleAccount.roleId !== null) {
        localStorage.roleId = data.account.roleAccount.roleId
        state.roleId = data.account.roleAccount.roleId
      } else {
        localStorage.roleId = '2'
        state.roleId = '2'
      }
      localStorage.accountId = data.account.id
      state.accountId = data.account.id
      localStorage.userName = data.account.login
      state.userName = data.account.login
      // 是否是营销账号
      localStorage.isMarketAccount = data.isMarketAccount
      state.isMarketAccount = data.isMarketAccount      
    },
    loginId(state, data){
      localStorage.defaultId = data.defaultMachineId
      state.defaultId = data.defaultMachineId
      localStorage.defaultFactoryId = data.defaultFactoryId
      state.defaultFactoryId = data.defaultFactoryId
      localStorage.defaultShopId = data.defaultShopId
      state.defaultShopId = data.defaultShopId
    },
    loginRoute(state, data){
      localStorage.newroute = data
      state.newroute = data
    },
    loginOut (state) {
      localStorage.removeItem('authority')
      state.authority = ''
      localStorage.removeItem('token')
      state.token = ''
      localStorage.removeItem('expireTime')
      state.expireTime = ''
      localStorage.removeItem('authCode')
      state.authCode = ''
      localStorage.removeItem('roleId')
      state.roleId = ''
      localStorage.removeItem('defaultId')
      state.defaultId = ''
      localStorage.removeItem('defaultFactoryId')
      state.defaultFactoryId = ''
      localStorage.removeItem('defaultShopId')
      state.defaultShopId = ''
      localStorage.removeItem('accountId')
      state.accountId = ''
      localStorage.removeItem('userName')
      state.userName = ''
      localStorage.removeItem('isMarketAccount')
      state.isMarketAccount = ''
      localStorage.removeItem('newroute')
      state.newroute = ''
    },
    setHistoryToStore (state) {
      state.authority = JSON.parse(localStorage.getItem('authority'))
      state.token = localStorage.getItem('token')
      state.expireTime = localStorage.getItem('expireTime')
      state.authCode = localStorage.getItem('authCode')
      state.newroute = localStorage.getItem('newroute')
      state.factoryId = localStorage.getItem('factoryId')
      if (localStorage.getItem('lang') !== null) {
        state.lang = Number(localStorage.getItem('lang'))
      }
      state.roleId = localStorage.getItem('roleId')
      if (localStorage.getItem('isCollapse') !== null) {
        state.isCollapse = JSON.parse(localStorage.getItem('isCollapse'))
      }
      state.defaultId = localStorage.getItem('defaultId')
      state.defaultFactoryId = localStorage.getItem('defaultFactoryId')
      state.defaultShopId = localStorage.getItem('defaultShopId')
      state.accountId = localStorage.getItem('accountId')
      state.userName = localStorage.getItem('userName')
      state.isMarketAccount = localStorage.getItem('isMarketAccount')
    },
    setDateBnt (state,data){
      [state.dateBtn1,state.dateBtn2,state.dateBtn3,state.dateBtn4,state.dateBtn5] = data
    },
    clearData(state){
      state.machineID = []
      state.selectOptions = []
      state.selectValue = []
      state.shiftTime = ''
      state.dateBtn1 = ''
      state.dateBtn2 = ''
      state.dateBtn3 = ''
      state.dateBtn4 = ''
      state.dateBtn5 = ''
      state.startPicker=''
      state.endPicker=''
    },
    nowsign(state,data){
      state.sign = sha256.hmac(String(state.token), String(data) + String(state.authCode))
    },
    authority(state,data){
      state.authority=JSON.parse(localStorage.getItem('authority'))
      switch (data) {
        case '/':
          if (state.authority.Home.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case 'EquipmentDashBoard':
          if (state.authority.EquipmentDashboard.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;  
        case '/EP001':
          if (state.authority.ProductionAnalysis.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;  
        case '/ES001':
          if (state.authority.EquipmentStepAnalysis.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/TS001':
          if (state.authority.SingleTireStepAnalysis.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/ER002':
          if (state.authority.ReloadingAnalysis.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/EF001':
          if (state.authority.EquipmentFaultAlarm.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/CD001':
          if (state.authority.CycleDistribution.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/ER001':
          if (state.authority.ReloadingStatistics.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/PF001':
          if (state.authority.ProductivityForecast.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/AV001':
          if (state.authority.AnalogValueAnalysis.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/EG001':
          if (state.authority.EventGantt.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/ES003':
          if (state.authority.StepStatisticsReport.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;
        case '/VPN001':
          if (state.authority.VpnBoxApply.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;  
        case '/VPN002':
          if (state.authority.VpnBoxReview.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break;  
        case '/VPN003':
          if (state.authority.VpnBoxManage.show === false) {
            router.push({path: '/', name: 'home'})
          }
          break; 
      }
    },
    // 清除缓存后 如果无权限数据跳转至登录页
    toLogin(){
      if (window.localStorage.getItem('token') === null) {
        router.push({path: '/login', name: 'login'})
      }
    },
    // 如果是营销账号 将工厂名改成******
    marketAccount(state, data){
      if(state.lang===0){
        data[0].label = '*****factory'
      }else{
        data[0].label = '*****工厂'
      }
    },
    marketAccountShop(state,data){
      if(state.lang===0){
        data[0].label = '*****factory'
        data[0].children[0].label = '*****Tire Building workshop'
      }else{
        data[0].label = '*****工厂'
        data[0].children[0].label = '*****全钢成型车间'
      }
    },
    // 小程序跳转后保存登录信息
    axiosValue(state,data){
      localStorage.token = data.token
      state.token = data.token
      localStorage.authCode = data.auth_Code
      state.authCode = data.auth_Code
      localStorage.newroute = data.route
      state.newroute = data.route
      localStorage.factoryId= data.factory_id
      state.factoryId = data.factory_id
    }
  }
})
